export const stringsKey = "TemplatesAwaitingApproval";
export const englishStrings = {
	selectCountryLabel: "Select Country",
	selectTemplateTypeLabel: "Template Type",
	countryListErrorMessage: "Error loading country list, Please try again",
	templateListFilterErrorMessage:
		"Error loading template list, Please try again",
	approveTemplateSuccessMessage: "Approve template request saved successfully",
	approveTemplateErrorMessage:
		"Error in approve template request, Please try again",
	rejectTemplateSuccessMessage: "Reject template request saved successfully",
	rejectTemplateErrorMessage:
		"Error in reject template request, Please try again",
	templateListErrorMessage: "Failed to load template list!",
	title: "Batch Messages Awaiting Approval",
	rejectTemplateConfirmationMessage:
		"Are you sure you want to reject template configuration?",
	deleteButtonText: "Yes",
	cancelButtonText: "No",
};
